import React from 'react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white" data-id="element-114" data-mp="30h7lnpdg7uuk">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:px-6 sm:py-8" data-id="element-115" data-mp="30iip1o2zf0l5">
        <SectionHeading id="problema" eyebrow="¿Te suena familiar?" title="Quieres aprender seguridad electrónica, pero no sabes por dónde empezar." subtitle="Si estás comenzando desde cero o quieres ampliar tus conocimientos, probablemente conozcas alguna de estas situaciones:" data-id="element-116" data-mp="2vpg587o0b5i5" />

        <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-117" data-mp="3jfag4jormjzr">
          {problems.map((p, i) => <Reveal key={p.title} as="li" delay={i * 0.03} className="flex gap-3 rounded-xl bg-mist p-3" data-id="element-118" data-mp="3ehigt4lsjvlj" data-mpi={i}>
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-119" data-mp="1k3zk1wzl4h1a">
                {p.emoji}
              </span>
              <div data-id="element-120" data-mp="jeof04qybel2">
                <h3 className="font-display text-sm font-extrabold text-navy" data-id="element-121" data-mp="jbael21ulfg9">
                  {p.title}
                </h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-graphite-muted sm:text-sm" data-id="element-122" data-mp="se1q11uq4b7w">
                  {p.desc}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}